/** @module Specification/PartMaterialSize/PMSSizeSupplierCodeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/html",
	"csi/xml"
], function(declare, StringRen, html, xml) {

	return declare(StringRen, {

		/**
		 * @override
		 * Handles display of supplier code on PartMaterial.CommonSize and PartMaterialSize.PMSSize based on custom view setting for Display Supplier Codes
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var node = ctx.getNode();

			if (!node || !ctx.view.displaySupplierCodes) {
				return false;
			}

			var cache = ctx.cache;
			var size = cache.get(node.CommonSize) || cache.get(node.PMSSize);
			var quote = cache.get(node.BOMLineQuote) || cache.get(ctx.getNodeParent().BOMLineQuote);
			if (size && quote) {
				var productSource = cache.get(quote.__Parent__);
				var codes = productSource && productSource.SizeCodes;
				var code = codes && codes[size.SysID];
				if (code) {
					html.setInnerText(refNode, "(" + code + ")");
				}
			}
			return true;
		}

	});
});